import request from "../../utils/request";

export function doDetailLiveTracking(token) {
  return request(`/orders/find-order-by-token/${token}`, {
    method: "GET",
  });
}
